import { REGEX_PATTERNS } from '../../regex';

const SEGMENT_DELIMITER = REGEX_PATTERNS.stringManipulation.KEBAB_UNDERSCORE_SEGMENT_DELIMITER.regex;

/**
 * @group Functions
 * @summary <blockquote>Converts a string to Title Case.</blockquote>
 *
 * Splits on kebab-case, underscore, or space delimiters and capitalizes each word with spaces between them.
 *
 * @param str - Input string (e.g. "my-workflow-step", "my_step_name")
 * @returns Title Case string (e.g. "My Workflow Step", "My Step Name")
 * @example
 * ```typescript
 * toTitleCase('my-workflow-step'); // 'My Workflow Step'
 * toTitleCase('user_name');        // 'User Name'
 * ```
 */
export function toTitleCase(str: string): string {
  return str
    .split(SEGMENT_DELIMITER)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}
